/**
 * File categories supported by the backend.
 */
export const FileCategory = {
  Input: 0,
  Output: 1,
  Generated: 2,
  Attachment: 3,
  Temporary: 4,
  Artifact: 5,
  Log: 6,
} as const;

export type FileCategory = (typeof FileCategory)[keyof typeof FileCategory];

/**
 * DTO returned by the API for session file metadata.
 */
export interface AgentSessionFileDto {
  id: string;
  tenantId: string;
  projectId?: string | null;
  sessionId: string;
  fileName: string;
  originalFileName: string;
  contentType: string;
  fileSizeBytes: number;
  category: FileCategory;
  version: number;
  isLatestVersion: boolean;
  description?: string | null;
  metadataJson?: string | null;
  createdAt: string;
  updatedAt: string;
}

/**
 * DTO returned by the API for file version history.
 */
export interface AgentSessionFileVersionDto {
  id: string;
  fileId: string;
  versionNumber: number;
  fileSizeBytes: number;
  changeDescription?: string | null;
  createdAt: string;
}

